import { withInstall } from '../_util'

import RichTextEditor from './RichTextEditor'

export type { RichTextEditorProps } from "./RichTextEditor"

export default withInstall<typeof RichTextEditor, {}>(
  RichTextEditor
)
